<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:22:12
 * @FilePath: /smartEarthDemo/src/demo/earth/loadRailway.vue
 * @Description: 
-->
<template>
    <div id="cesiumContainer"></div>
</template>
<script>
import util from "../../components/util"
export default {
    data () {
        return {

        }
    },
    mounted () {
     this.init()
    },
    methods : {
      init () {
                  let viewer = util.getViewer("cesiumContainer",{
                      infoBox: true,
                      selectionIndicator: true,
                  });
                let promise = Cesium.GeoJsonDataSource.load('/demo/static/data/geojson/bj-railway.geojson');
                 promise.then(function (dataSource) {
                    viewer.dataSources.add(dataSource);
                    let entities = dataSource.entities.values;

                    let colorHash = {};
                    for (let i = 0; i < entities.length; i++) {
                        let entity = entities[i];

                        let name = entity.name;
                        let color = colorHash[name];
                        if (!color) {
                            color = Cesium.Color.fromRandom({
                                alpha: 1.0
                            });
                            colorHash[name] = color;
                        }
                        entity.polyline.material = color;
                        // entity.polygon.outline = true;
                        // entity.polygon.extrudedHeight = entity.properties.Population / 50.0;
                    }
                    viewer.zoomTo(entities);
                }).otherwise(function (error) {
                    window.alert(error);
                });
         }
    }
}
</script>
<style scoped>
  #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
